import React, { useContext } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { isDesktop } from "react-device-detect";

//ads
import Caja3 from '../../ads/Caja3';

//context
import GalleryContext from '../../context/GalleryContext';

//components
import Loading from '../common/Loading';
import BackgroundImage from '../common/BackgroundImage';
import Button from '../common/Button';
import EmptySpace from '../common/EmptySpace';

const Home = () => {

    const { dataGallery, loading } = useContext(GalleryContext);
    const { backgroudColorButton, colorButton, gallery, queryStringText, qryStrStart, title, epigraph, epigraphColor, titleColor, urlAssets, urlEspecial, textButton } = dataGallery;

    const firstPhoto = gallery ? (Object.keys(gallery)).shift() : '';

    return (
        loading
            ? <Loading /> 
            : <section className="position-relative">
                    <section className="position-relative gallery-home">
                        <BackgroundImage urlAssets={urlAssets} alt={title} />
                        <article className="position-absolute start-50 translate-middle-x mx-auto w-100 text-center cont-layout container-titular">
                            <LazyLoadImage
                                alt={title}
                                className="img-fluid"
                                effect="blur"
                                src={`${urlAssets}img/portada.png`}
                            />
                            <h1 className="my-4 title" style={{ color: titleColor }}>{title}</h1>
                            <p className={`mx-auto my-1 my-md-3 px-2 px-md-0 epigraph`} style={{ color: epigraphColor }}>{epigraph}</p>
                            <Button 
                                styles={{ backgroundColor: backgroudColorButton, color: colorButton }} 
                                text={textButton}
                                url={`${urlEspecial}${qryStrStart}${queryStringText}=${firstPhoto}`}
                            />
                            <section className="content-msgs">
                                {!isDesktop && <Caja3 />}        
                            </section>      
                            <EmptySpace />
                        </article>
                    </section>            
                </section>
    )
}

export default Home
